const initialState = {
    mainSlider: [],
    adsSlider: [],
    features: [],
    projects: [],
    articles: [],
    
};
const main = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_MAIN':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default main;
